import React from 'react';

export const competitionRoute = [
  {
    path: '/competition/home',
    component: React.lazy(() => import('@/views/competition/index')),
    meta: {
      title: '赛事'
    }
  }
  // {
  //   path: '/competition/zone',
  //   component: React.lazy(() => import('@/views/competition/zone')),
  //   meta: {
  //     title: '专区'
  //   }
  // },
  /* {
    path: '/competition/live',
    component: React.lazy(() => import('@/views/competition/live')),
    meta: {
      title: '直播'
    }
  } */
];
